<script lang="ts" module>
  import type { AiSuggestion as AiSuggestionApiResult } from '@/teoCore/TeoApi';
  import type { AISuggestionPromptId } from '@/teoCore/text/AIHandler/aiSuggestionPresets';
  import { type AISuggestion } from '@/teoCore/text/AIHandler/SelectionSuggestionHandler';
  import AISuggestions from '@/ui/elements/assistant/next/AISuggestions/AISuggestions.svelte';
  import InfoCard from '@/ui/elements/card/InfoCard.svelte';

  import { type AIContentHeaderProps } from './AIContentHeader.svelte';
  import { type AIStyleProps } from './AIStyle.svelte';
  import { type AISuggestionProps } from './AISuggestion.svelte';

  interface AdditionalProps {
    aiDescription?: string;
    /** Called whenever the suggestion the user is looking at changes. */
    onSuggestionShown?: (suggestion: AISuggestion | undefined) => void;
    promptItems?: AIStyleProps['aiStyleItems'];
    promptItemSelected?: string;
    onPromptSelect?: (item: AISuggestionPromptId) => void;
    onLoadAiSuggestionClick: (type: string) => void;
    onRemoveSuggestion?: (index: number) => void;
    loading?: boolean;
  }

  export type AIContainerProps = AIStyleProps &
    Omit<AIContentHeaderProps, 'pages' | 'tpi' | 'current'> &
    Omit<AISuggestionProps, 'aiSuggestions' | 'showSuggestion'> & {
      aiSuggestions: AISuggestion[];
    } & AdditionalProps;
</script>

<script lang="ts">
  let props: Readonly<AIContainerProps> = $props();
  let curPage = $state(0);

  $effect(() => {
    curPage = Math.max((props.aiSuggestions.length ?? 0) - 1, 0);
  });

  $effect(() => {
    props.onSuggestionShown?.(props.aiSuggestions[curPage]);
  });

  function handlePromptSelect(item: string): void {
    props.onPromptSelect?.(item as AISuggestionPromptId);
  }

  function handleRemoveSuggestion(index: number): void {
    if (props.onRemoveSuggestion) {
      props.onRemoveSuggestion(index);
      return;
    }
    props.aiSuggestions.splice(index, 1);
  }
  function toAiSuggestions(suggestions: AISuggestion[]): AiSuggestionApiResult[] {
    return suggestions.map((suggestion) => ({
      text: suggestion.replacement,
      hidden: suggestion.hidden ?? false,
      teo_result: {
        tpi: {
          percentage: suggestion.tpi,
        },
      },
      context: suggestion.context,
    }));
  }
</script>

<div class="grid gap-3">
  <!-- {#if !!props.promptItems?.length}
    <DropDown
      items={props.promptItems}
      disabled={props.promptItems.length <= 1}
      selected={props.promptItemSelected ?? props.promptItems[0]?.value ?? ''}
      onItemClick={props.onPromptSelect}
    ></DropDown>
  {/if} -->
  {#if props.aiDescription}
    <InfoCard shortText={props.aiDescription} dimension="white"></InfoCard>
    <hr class="border-t-c-divider" />
  {/if}
  <!-- {#if props.aiSuggestions.length > 0} -->
  <AISuggestions
    loading={props.loading}
    suggestions={toAiSuggestions(props.aiSuggestions)}
    onRemoveSuggestion={handleRemoveSuggestion}
    onLoadAiSuggestionClick={props.onLoadAiSuggestionClick}
    promptItems={props.promptItems}
    promptItemSelected={props.promptItemSelected}
    onPromptSelect={handlePromptSelect}
  />
</div>
